import { socket } from '@/api/socket';
import { SOCKET_EVENTS } from '@/api/socket-events';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogFooter, DialogTrigger } from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import type { IBalance } from '@/entities/balance.entity';
import type { IClient } from '@/entities/client.entity';
import { EditIcon } from 'lucide-react';
import { useState, type FormEvent } from 'react';
import { toast } from 'sonner';

export default function ChangeCommentModal({ currentComment, client, balance }: { currentComment?: string; client?: IClient; balance?: IBalance }) {
	const [text, setText] = useState(currentComment ?? '');
	const [isOpen, setIsOpen] = useState(false);

	function handleSubmit(e: FormEvent) {
		if (e.preventDefault) e.preventDefault();
		if (text === (currentComment ?? '')) return toast.error('Комментарий не изменён');
		if (client) {
			socket.emit(SOCKET_EVENTS.changeClientComment, { clientId: client.id, comment: text });
		} else if (balance) {
			socket.emit(SOCKET_EVENTS.changeBalanceComment, { balanceId: balance.id, comment: text });
		}
		setIsOpen(false);
	}

	return (
		<Dialog
			open={isOpen}
			onOpenChange={open => {
				setIsOpen(open);
				if (open) setText(currentComment ?? '');
			}}
		>
			<form>
				<DialogTrigger asChild>
					<Button className='h-4 w-4 p-0' variant='ghost' onClick={() => setIsOpen(true)}>
						<EditIcon />
					</Button>
				</DialogTrigger>
				<DialogContent className='sm:max-w-[440px]'>
					<div className='flex gap-1 flex-col'>
						<Label className='text-md'>Введи комментарий для {client ? 'клиента' : 'баланса'}</Label>
						<Input className='w-full' value={text} onChange={e => setText(e.target.value)} />
					</div>

					<DialogFooter>
						<Button onClick={handleSubmit} disabled={text === (currentComment ?? '')}>
							Изменить
						</Button>
					</DialogFooter>
				</DialogContent>
			</form>
		</Dialog>
	);
}
